import { ElMessageBox } from 'element-plus';
import { removeToken, removeUserInfo } from '@/configs/coalEduAuth';
import { pauseRegisteredPlayback } from '@/pages/course/composables/coursePlay/event/usePlaybackGuard';

let isOpenMessageBox = false;

const commonMessageBoxParams = {
  confirmButtonText: '确定',
  showCancelButton: false,
  closeOnClickModal: false,
  closeOnPressEscape: false,
  showClose: false,
};

/**
 * 处理 HTTP 响应状态码（401/403）
 * @returns false 表示已处理，拦截器应吞掉错误；true 表示未处理，继续 reject
 */
export function handleResponseStatus(
  status: number,
  message?: string,
  notLogin?: number,
): boolean {
  if (notLogin === "-1") {
    return true;
  }

  switch (status) {
    case 401:
      // 播放页会注册 pause；其他页面为空操作
      pauseRegisteredPlayback();
      removeToken();
      removeUserInfo();
      if (isOpenMessageBox) return false;
      isOpenMessageBox = true;
      ElMessageBox.confirm(
        `${message || '登录失效，请重新登录！'}，即将刷新页面`,
        '提示',
        commonMessageBoxParams,
      )
        .then(() => {
          window.location.reload();
        })
        .finally(() => {
          isOpenMessageBox = false;
        });
      return false;

    case 403:
      if (isOpenMessageBox) return false;
      isOpenMessageBox = true;
      ElMessageBox.confirm(message || '无权限', '提示', commonMessageBoxParams)
        .then(() => {
          window.location.href = window.location.origin;
        })
        .finally(() => {
          isOpenMessageBox = false;
        });
      return false;

    default:
      return true;
  }
}
